import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import AppStore from "../images/App Store - Filled.png";
import fb from "../images/facebook.svg";
import GooglePlay from "../images/Google Play.png";
import NetKgTracker from "../NetKgTracker"; //PROD: only for production. UAT: nothing
import ig from "../images/instagram.svg";
import yt from "../images/youtube.svg";
import "./Footer.scss";

const Footer = () => {
  const [t] = useTranslation("global");
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          {/* Навигация */}
	  {<NetKgTracker />} {/* PROD: only for production. UAT: nothing */}
          <div className="footer__section">
            <h3 className="footer__title">{t("footer.nav")}</h3>
            <nav className="footer__nav">
              <NavLink
                className={({ isActive }) => 
                  `footer__link ${isActive ? "footer__link--active" : ""}`
                }
                to="/"
              >
                {t("footer.main")}
              </NavLink>
              <NavLink
                className={({ isActive }) => 
                  `footer__link ${isActive ? "footer__link--active" : ""}`
                }
                to="/petitions"
              >
                {t("footer.petitions")}
              </NavLink>
              <NavLink
                className={({ isActive }) => 
                  `footer__link ${isActive ? "footer__link--active" : ""}`
                }
                to="/analytics"
              >
                {t("footer.analytics")}
              </NavLink>
            </nav>
          </div>

          {/* Проект */}
          <div className="footer__section">
            <h3 className="footer__title">{t("footer.project")}</h3>
            <nav className="footer__nav">
              <NavLink
                className={({ isActive }) => 
                  `footer__link ${isActive ? "footer__link--active" : ""}`
                }
                to="/about"
              >
                {t("footer.about")}
              </NavLink>
              <NavLink
                className={({ isActive }) => 
                  `footer__link ${isActive ? "footer__link--active" : ""}`
                }
                to="/contacts"
              >
                {t("footer.contacts")}
              </NavLink>
              <NavLink
                className={({ isActive }) => 
                  `footer__link ${isActive ? "footer__link--active" : ""}`
                }
                to="/privacy"
              >
                {t("footer.privacy")}
              </NavLink>
            </nav>
          </div>

          {/* Социальные сети */}
          <div className="footer__section">
            <h3 className="footer__title">{t("footer.contacts")}</h3>
            <div className="footer__socials">
              <a 
                href={process.env.REACT_APP_YOUTUBE_URL}
                className="footer__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <img src={yt} alt="YouTube" />
              </a>
              <a 
                href={process.env.REACT_APP_FACEBOOK_URL}
                className="footer__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img src={fb} alt="Facebook" />
              </a>
              <a 
                href={process.env.REACT_APP_INSTAGRAM_URL}
                className="footer__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img src={ig} alt="Instagram" />
              </a>
            </div>
          </div>

          {/* Мобильные приложения */}
          <div className="footer__section">
            <h3 className="footer__title">{t("footer.download")}</h3>
            <div className="footer__apps">
              <a
                href={process.env.REACT_APP_GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__app-link"
                aria-label="Скачать в Google Play"
              >
                <img src={GooglePlay} alt="Google Play" />
              </a>
              <a
                href={process.env.REACT_APP_APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__app-link"
                aria-label="Скачать в App Store"
              >
                <img src={AppStore} alt="App Store" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer__bottom">
          <div className="footer__divider"></div>
          <div className="footer__copyright">
            <p className="footer__copyright-text">
              © Copyright {new Date().getFullYear()} - {t("footer.copyright")}
            </p>
            <p className="footer__eu-text">
              {t("footer.EU")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
